export default __webpack_public_path__ + "static/media/error.4610d347.m4a";